import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AppRegistrationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"app_registration"}/>
}
